// removed by extract-text-webpack-plugin
module.exports = {"sub-section-heading":"CollapsedCartView__sub-section-heading","subSectionHeading":"CollapsedCartView__sub-section-heading","cart-icon-styles":"CollapsedCartView__cart-icon-styles","cartIconStyles":"CollapsedCartView__cart-icon-styles","toggle-arrow-styles":"CollapsedCartView__toggle-arrow-styles","toggleArrowStyles":"CollapsedCartView__toggle-arrow-styles","view-cart-link":"CollapsedCartView__view-cart-link","viewCartLink":"CollapsedCartView__view-cart-link"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/CollapsedCartView/CollapsedCartView.scss
// module id = 2326
// module chunks = 8